/*!
 *
 *  scroll-anim.ts
 *
 */
export default function scrollAnimation() {
    var elems = document.querySelectorAll('.u-sa');
    var targets = Array.from(elems, function (elem) { return ({
        top: elem.getBoundingClientRect().top + window.scrollY,
        elem: elem
    }); });
    function onScroll() {
        var _top = window.pageYOffset;
        for (var i = targets.length - 1; i >= 0; i--) {
            var item = targets[i];
            if (_top + (window.innerHeight / 2) + (window.innerHeight / 3) > item.top) {
                item.elem.classList.add('-active');
                targets.splice(i, 1);
            }
        }
        if (targets.length === 0) {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', updateTop);
        }
    }
    function updateTop() {
        targets.forEach(function (target) {
            target.top = target.elem.getBoundingClientRect().top + window.scrollY;
        });
    }
    onScroll();
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', updateTop);
}
